var _circle, _path, _linearGradient, _circle2, _circle3, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _circle4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Construction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 31.5,
    r: 1.5,
    fill: "#35c1f1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#199be2",
    d: "M6.064,42.059l2.787,1.094l6.906-13.478l3.02,5.049l1.264,8.13l3.089-0.354v-8.311 c0-0.338-0.061-0.673-0.179-0.989L21,28l-9.938-3.567L6.064,42.059z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "KkaQByuPSbwOg9iwg6I6ha",
    x1: 25.323,
    x2: 26.806,
    y1: 4.243,
    y2: 12.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 8,
    r: 4,
    fill: "url(#KkaQByuPSbwOg9iwg6I6ha)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 42.5,
    r: 1.5,
    fill: "#199be2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#199be2",
    d: "M21.5,41c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.631-0.672,1.631-1.5S22.328,41,21.5,41z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "KkaQByuPSbwOg9iwg6I6hb",
    x1: 4.535,
    x2: 40.19,
    y1: 29.097,
    y2: 29.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eba84b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#e9a144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#e28d31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d97218"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KkaQByuPSbwOg9iwg6I6hb)",
    d: "M39.189,37.786c-0.139,0-0.28-0.029-0.415-0.091L5.119,22.316 c-0.502-0.229-0.723-0.822-0.493-1.325c0.229-0.501,0.82-0.724,1.325-0.493l33.655,15.379c0.502,0.229,0.723,0.822,0.493,1.325 C39.932,37.569,39.569,37.786,39.189,37.786z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "KkaQByuPSbwOg9iwg6I6hc",
    x1: 35.56,
    x2: 38.568,
    y1: 33.058,
    y2: 45.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d94a23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c3519"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KkaQByuPSbwOg9iwg6I6hc)",
    d: "M45,44H28.726c-0.637,0-0.956-0.77-0.505-1.22l10.06-10.06c0.95-0.95,2.49-0.95,3.44,0 l4.694,4.694C46.789,37.789,47,38.298,47,38.828V42C47,43.104,46.105,44,45,44z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 21.5,
    r: 1.5,
    fill: "#35c1f1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M14.365,15.698l-2.588,7.462l9.569,4.372l1.426-6.167l1.684,7.588l3.35,1.531l-1.749-12.308 c-0.176-1.242-0.919-2.331-2.009-2.95l-6.154-3.491c-1.026-0.582-2.254-0.687-3.364-0.289l-5.091,1.829 c-0.607,0.218-1.12,0.639-1.452,1.191l-3.784,6.286l2.507,1.624l4.049-5.737L14.365,15.698z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Construction);
export default __webpack_public_path__ + "static/media/icons8-construction.f796f059ced7c93e928266f58b1bb67d.svg";
export { ForwardRef as ReactComponent };